import { render, staticRenderFns } from "./moneyListTable.vue?vue&type=template&id=cb66de5c&scoped=true"
import script from "./moneyListTable.vue?vue&type=script&lang=js"
export * from "./moneyListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb66de5c",
  null
  
)

export default component.exports